module.exports = __webpack_public_path__ + "img/logo-groupe-emc-alone.7cf2f27e.svg";